import { render, staticRenderFns } from "./Y2.vue?vue&type=template&id=33a0fa08"
import script from "./Y2.vue?vue&type=script&lang=js"
export * from "./Y2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports